import 'antd/dist/reset.css';
import './global.css';

import React from 'react';
import ReactDOM from 'react-dom/client';

import App from '@/app/App';
import ErrorBoundary from '@/components/ErrorBoundary';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
);

root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>,
);
